import { configureStore, createSlice } from '@reduxjs/toolkit'

let login = createSlice({
    name: 'login',
    initialState: { value: false },
    reducers: {
        checkLogin(state, action) {
            state.value = action.payload
        }
    }
})

let loca = createSlice({
    name: 'loca',
    initialState: { value: "dashboard" },
    reducers: {
        checkLoca(state, action) {
            state.value = action.payload
        }
    }
})

let sidebarTab = createSlice({
    name: 'sidebarTab',
    initialState: { value: true },
    reducers: {
        checkSidebarTab(state, action) {
            state.value = action.payload
        }
    }
})

let message = createSlice({
    name: 'message',
    initialState: { value: { code: 0, msg: "" } },
    reducers: {
        changeMessage(state, action) {
            state.value = action.payload
        }
    }
})

export let { checkLogin } = login.actions
export let { checkLoca } = loca.actions
export let { checkSidebarTab } = sidebarTab.actions
export let { changeMessage } = message.actions

export default configureStore({
    reducer: {
        login: login.reducer,
        loca: loca.reducer,
        sidebarTab: sidebarTab.reducer,
        message: message.reducer,
    }
}) 